import { makeStyles } from '@material-ui/core'
import { colors } from 'shared/styles/colors'

export const useStyles = makeStyles(() => ({
  root: {
    '& .MuiStepIcon-active': { color: colors.green },
    '& .MuiStepIcon-completed': { color: colors.green },
  },
}))
